import React from "react";

// Placeholder component for embedded form.io forms.
// Will be implemented when the external form feature is fully wired up.
const EmbeddedFormio = () => {
  return null;
};

export default EmbeddedFormio;
